import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FormLabel from '../FormLabel';
import FormError from '../FormError';
import { StyledSelectContainer, StyledSelectWrapper, StyledSelect, StyledSelectOption } from './styled';

const Select = forwardRef(({ id, placeholder, label, name, value, error, fullWidth, disabled, errorText, color, options, noBorder, customStyle, font, readonly, onChange, firstEnable }, ref) => {
  return (
    <StyledSelectContainer
      disabled={disabled}
      readonly={readonly}
      error={error}
      fullWidth={fullWidth}
      customStyle={customStyle}
    >
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}
      <StyledSelectWrapper
        noBorder={noBorder}
      >
        <StyledSelect
          ref={ref}
          id={id}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          value={value}
          color={color}
          font={font}
          readOnly={readonly}
        >
          {
            placeholder &&
            <StyledSelectOption
              value=""
              disabled={!firstEnable}
            >
              {placeholder}
            </StyledSelectOption>
          }
          {
            options &&
            options.map((option) => (
              <StyledSelectOption
                key={option?.value}
                value={option?.value}
              >
                {option?.label}
              </StyledSelectOption>
            ))
          }
        </StyledSelect>
      </StyledSelectWrapper>
      {error && errorText && <FormError>{errorText}</FormError>}
    </StyledSelectContainer>
  )
});

Select.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  color: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })),
  noBorder: PropTypes.bool,
  customStyle: PropTypes.array,
  font: PropTypes.any,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  firstEnable: PropTypes.bool
};

Select.defaultProps = {
  value: "",
  error: false,
  fullWidth: false,
  disabled: false,
  options: [],
  noBorder: false,
  readonly: false,
  onChange: undefined,
  firstEnable: false
};

export default React.memo(Select);